import React from "react";
import { Box, Typography, Paper, IconButton, useTheme } from "@mui/material";
import { Chat } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { ProjectData, Tool } from "../../interfaces/TaskDetails";
import useResponsive from "../../hooks/useResponsive";

export type IProjectDetailsProps = {
  projectData: ProjectData | null;
  tool: Tool[];
  medewerkers: string;
  isFlag: number | null;
  onFlagStatusChange: () => void;
  setIsLoading: () => void;
  isFlexRole: number;
  handleOpenRemarksDialog?: () => void;
};

const ProjectDetailsField: React.FC<IProjectDetailsProps> = ({
  projectData,
  isFlexRole,
  handleOpenRemarksDialog
}) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const { isMobile, isTablet, isDesktop } = useResponsive();
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: isMobile || isTablet ? "90%" : "100%",
        mt: "5px",
      }}
    >
      {/* Green Paper Container */}
      <Paper
        sx={{
          p: 2,
          bgcolor: theme.palette.blueColors.main,
          width: isMobile || isTablet ? "100%" : "90%",
          borderRadius: "10px",
        }}
      >
        <Box>
          {/* Project Name */}
          <Box sx={{ display: "flex", mb: 1 }}>
            <Typography
              fontFamily={"Nunito Sans Regular700"}
              fontSize={"14px"}
              sx={{
                width: "50%",
                mr: 1,
                color: theme.palette.secondary.main,
              }}
            >
              Projectnaam
            </Typography>
            <Box
              sx={{
                width: "80%",
                color: theme.palette.secondary.main,
                fontFamily: "Nunito Sans Regular700",
                fontSize: "14px",
                display: "flex",
                alignItems: "center",
              }}
            >
              {projectData?.project_name}
            </Box>
          </Box>

          {/* PM Description / Omschrijving */}
          {projectData?.task_remarks && (
            <Box sx={{ display: "flex", mb: 1 }}>
              <Typography
                fontFamily={"Nunito Sans Regular700"}
                fontSize={"14px"}
                sx={{
                  width: "50%",
                  mr: 1,
                  color: theme.palette.secondary.main,
                }}
              >
                Omschrijving
              </Typography>
              <Box
                sx={{
                  width: "80%",
                  color: theme.palette.secondary.main,
                  fontFamily: "Nunito Sans Regular700",
                  fontSize: "14px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {projectData.task_remarks}
              </Box>
            </Box>
          )}

          {/* Remarks - Show chat icon for flex workers only */}
          {isFlexRole === 1 && (
            <Box sx={{ display: "flex", mb: 1 }}>
              <Typography
                fontFamily={"Nunito Sans Regular700"}
                fontSize={"14px"}
                sx={{
                  width: "50%",
                  mr: 1,
                  color: theme.palette.secondary.main,
                }}
              >
                Opmerking
              </Typography>
              <Box
                sx={{
                  width: "80%",
                  color: theme.palette.secondary.main,
                  fontFamily: "Nunito Sans Regular700",
                  fontSize: "14px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <IconButton onClick={handleOpenRemarksDialog} sx={{ padding: 0 }}>
                  <Chat fontSize="medium" sx={{ color: "#ffffff" }} />
                </IconButton>
              </Box>
            </Box>
          )}
        </Box>
      </Paper>
      {/* {isDesktop && (
        <Box
          sx={{
            display: "flex",
            width: "10%",
            justifyContent: "flex-end",
          }}
        >
          {isFlag === 1 ? (
            <Flag
              sx={{
                color: "red",
                fontSize: 40,
              }}
            />
          ) : (
            <IconButton
              onClick={onFlagStatusChange}
              sx={{
                padding: "0px",
              }}
            >
              <Flag
                sx={{
                  color: theme.palette.primary.main,
                  fontSize: 40,
                }}
              />
            </IconButton>
          )}
        </Box>
      )} */}
    </Box>
  );
};

export { ProjectDetailsField };
